module.exports = __webpack_public_path__ + "img/box5-08.b84f9d4f.png";